export class Buffer {
	buffer: WebGLBuffer
	size: number
	count: number

	constructor(gl: WebGL2RenderingContext, vertices: number[], size: number) {
		const buffer = gl.createBuffer()

		if (!buffer) {
			throw new Error("Could not create buffer")
		}

		this.size = size
		this.count = vertices.length / size
		this.buffer = buffer

		gl.bindBuffer(gl.ARRAY_BUFFER, buffer)
		gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW)
	}
}
